// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__17FsZ","description":"PatientConsentPreview_description__10Gw2"};